import SettingsCard_Sub from './SettingsCard_Sub'
import { faEraser } from '@fortawesome/free-solid-svg-icons'
import { useContext } from 'react'
import SettingsContext from '../../components/contexts/SettingsContext'

function Settings_Account() {
   const {setShowAlert} = useContext(SettingsContext)

   const showAlert = () => {
      setShowAlert(true)
   }

   return (
      <div className="settingsScreenSelected">
         <div className="headerSettingsSelected">Your Account</div>
         <ul className="settingsList">
            <li onClick={showAlert}>
               <SettingsCard_Sub
                  icon={faEraser}
                  name={'Deactivate account'}
                  isArrowed={false}
                  isActive={false}
                  description = {"Delete your account and erase all your data from us."}
               />
            </li>
         </ul>
      </div>
   )
}
export default Settings_Account
